import { render, staticRenderFns } from "./BulletinBoard.vue?vue&type=template&id=4678f1aa&scoped=true&"
import script from "./BulletinBoard.vue?vue&type=script&lang=js&"
export * from "./BulletinBoard.vue?vue&type=script&lang=js&"
import style0 from "./BulletinBoard.vue?vue&type=style&index=0&id=4678f1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4678f1aa",
  null
  
)

export default component.exports